import { gql } from "@apollo/client"

export const TOP_RATED_PROGRAM_INHOUSE = gql`
query getProgramsAll(
  $limit: Int = 8,
  $program_has_show: [uuid!] = []
) {
  programs:program_top_rated_program(
    limit: $limit, 
    where: {type: {_eq: "inhouse"}, id: {_nin: $program_has_show}},
    order_by: {final_rating: desc}
  ) {
    discount
    discount_price
    id
    price
    program_name
    program_thumbnail_url
    tp_name
    tp_profile_url
    tp_slug
    type
    slug
    category_slug
    category_name
    category_description
    training_duration
    training_times
    final_rating
    final_rating_participants
    created_at
  }
}

`

export type ProgramType = {
    discount: number
    discount_price: number
    id: string
    price: number
    program_name: string
    category_description: string
    program_thumbnail_url: string
    tp_name: string
    tp_profile_url: string
    tp_slug: string
    type: string
    slug: string
    category_slug: string
    training_duration: number
    category_name: string
    training_times: number
    final_rating: number
    final_rating_participants: number
    created_at: Date 
    custom_image: string
}

export type TopRatedProgramInhouseQuery = {
  programs : ProgramType []
}

export interface GetTopRatedInhouseProgramVariables {
  limit?: number;
  program_has_show?: string[];
}